import React from "react";
import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";
import InfoNotice from "./partials/info-notice.jsx";

const BOOQABLE_COMPANY = "45612a3d-883c-419d-8041-491810f11f48";
const SCRIPT_SRC = `https://${BOOQABLE_COMPANY}.assets.booqable.com/v2/booqable.js`;

class Shop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rendered: false
    };
    this.onLoad = this.onLoad.bind(this);
  }
  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  onLoad() {
    if (window.Booqable) {
      window.Booqable.init();
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.data && !this.state.rendered) {
      this.setState({ rendered: true });
      window.booqableOptions = {
        company: BOOQABLE_COMPANY
      };
      if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = SCRIPT_SRC;
        script.onload = this.onLoad;
        document.body.appendChild(script);
      } else {
        this.onLoad();
      }
    }
  }

  render() {
    return (
      <div>
        <style>{`
          #booqable-launcher {
            display: block !important;
            bottom: 20px !important;
            right: 95px !important;
          }

          #booqable-sidebar {
            right: 95px !important;
          }

          .booqable-product-list-wrapper .booqable-product-list-notice.clickable {
            margin-top: 30px !important;
          }
        `}</style>
        <h1>Eventive Hardware Shop</h1>
        <p style={{ fontSize: "12pt" }}>
          Rent or purchase hardware for your events.
        </p>
        <InfoNotice style={{ marginBottom: "2em", fontSize: "10pt" }}>
          Learn more about{" "}
          <a
            href="https://help.eventive.org/en/articles/5125284-equipment-rentals-purchases"
            target="_blank"
          >
            utilizing the Eventive Hardware Shop
          </a>
          .
        </InfoNotice>
        <div>
          <div
            style={{ fontWeight: "bold", fontSize: "14pt", marginBottom: 15 }}
          >
            Rental dates
          </div>
          <div style={{ width: 300 }}>
            <div className="booqable-datepicker"></div>
          </div>
        </div>
        <div style={{ marginTop: 30 }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "14pt",
              marginBottom: 18
            }}
          >
            Available for rental
          </div>
          <div style={{ margin: -15 }}>
            <div
              className="booqable-product-list"
              data-categories="rentals-82a0c498-22a9-4968-9a9e-8d843ce9d1a1"
            ></div>
          </div>
        </div>
        <div style={{ marginTop: 30 }}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "14pt",
              marginBottom: 18
            }}
          >
            Available for purchase
          </div>
          <div style={{ margin: -15 }}>
            <div
              className="booqable-product-list"
              data-categories="purchase-ec953cb4-225c-4cf3-9772-4a72c6569e7e"
            ></div>
          </div>
        </div>
      </div>
    );
  }
}

export default connectToStores(Shop);



// WEBPACK FOOTER //
// ./src/app/components/shop.jsx